import api from '@/api';

import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { arrayToObject } from '@/utils/helpers';

import { SET_ACCOUNT_EMAIL_DOMAINS, ADD_ACCOUNT_EMAIL_DOMAIN, UPDATE_ACCOUNT_EMAIL_DOMAIN } from './mutations';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const fetchAccEmailDomains = buildActionObject('fetchAccEmailDomains');
export const setAccEmailDomains = buildActionObject('setAccEmailDomains');
export const addAccEmailDomain = buildActionObject('addAccEmailDomain');
export const updateAccEmailDomain = buildActionObject('updateAccEmailDomain');
export const verifyDkim = buildActionObject('verifyDkim');
export const sendVerifyReplyToEmail = buildActionObject('sendVerifyReplyToEmail');
export const verifyReplyToEmailOtp = buildActionObject('verifyReplyToEmailOtp');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [fetchAccEmailDomains.action]({ dispatch }) {
		const accEmailDomains = await api.listAccountEmailDomains();
		const accEmailDomainsObj = arrayToObject(accEmailDomains);
		await dispatch(setAccEmailDomains.action, { accEmailDomains: accEmailDomainsObj });
	},
	[setAccEmailDomains.action]({ commit }, { accEmailDomains }) {
		commit(SET_ACCOUNT_EMAIL_DOMAINS, accEmailDomains);
	},
	async [addAccEmailDomain.action]({ commit }, payload) {
		const resp = await api.createAccountEmailDomain(payload);
		commit(ADD_ACCOUNT_EMAIL_DOMAIN, resp);
		return resp;
	},
	async [verifyDkim.action]({ commit }, accEmailDomainId) {
		const updatedAccEmailDomain = await api.verifyDkim(accEmailDomainId);
		commit(UPDATE_ACCOUNT_EMAIL_DOMAIN, updatedAccEmailDomain);
		return updatedAccEmailDomain;
	},
	async [sendVerifyReplyToEmail.action](_, email) {
		await api.sendVerifyReplyToEmail(email);
	},
	async [verifyReplyToEmailOtp.action](_, otp) {
		return await api.verifyReplyToEmailOtp(otp);
	},
};

export default actions;
